import { Box, BoxProps, ColorOptions, Loader, ModBox, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import ActionsMenu from '../../../components/ActionMenu/ActionsMenu'
import { Filters } from '../../../components/FiltersWeb'
import { filterTypes } from '../../../components/FiltersWeb/types'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { filtersData } from '../../../utils'
import { getCustomColumnWidth, myQueueHeaderTitles } from '../../../utils/constants'
import { EmType } from '../../EntityManagement'
import CreationStatus from '../../EntityManagement/Onboarding/CreationStatus'
const Header = ({ fetchDataOnChange, filterVisible, setFilterVisible, filterApplied }: any) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={'My Queue (Checker)'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearch={true}
          enableFilter
          showCalendar
          defaultPage={1}
          type="checker"
          filterApplied={filterApplied}
        />
      </ModBox>
    </Box>
  )
}

const MyQueue = () => {
  const {
    getCheckerMyQueList,
    getRowsSelected,
    currentPage,
    fetchMyCheckerList,
    updateMyQueueSelectedRow,
    updateAllMyQueRowsSelection,
    userName,
    selectedFilteredData,
    updateFilters,
    checkSelected,
    myCheckerListLength,
    setSideMenuRefresh,
    saveState,
    resetState,
    restoreFiltersToDefaults,
    setSearchFilterBy,
    resetFeePkgId,
    resetCheckerApplicationStatus,
  } = useStores((store) => ({
    getCheckerMyQueList: store.getCheckerMyQueList,
    getRowsSelected: store.getRowsSelected,
    currentPage: store.pagination.number,
    fetchMyCheckerList: store.getMyCheckerList,
    updateMyQueueSelectedRow: store.updateMyQueueSelectedRow,
    updateAllMyQueRowsSelection: store.updateAllMyQueRowsSelection,
    userName: store.user.name,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    checkSelected: store.filter.checkSelected,
    myCheckerListLength: store.myCheckerList.length,
    setSideMenuRefresh: store.setSideMenuRefresh,
    saveState: store.filter.saveState,
    resetState: store.filter.resetState,
    restoreFiltersToDefaults: store.filter.restoreFiltersToDefaults,
    applicationStatusLength: store.filter.applicationStatus.length,
    setSearchFilterBy: store.onboarding.setSearchFilterBy,
    resetFeePkgId: store.onboarding.resetFeePkgId,
    resetCheckerApplicationStatus: store.resetCheckerApplicationStatus,
  }))
  const navigation = useNavigation()
  const [listData, setListData] = useState<any>([])
  const [isLoading, setLoading] = useState(false)
  const [showStatus, setShowStatus] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)

  const [lazyFetchMyCheckerList, mycheckQueueHandler] = useLazyApiData(fetchMyCheckerList)

  useEffect(() => {
    if (mycheckQueueHandler.state === 'fulfilled' || mycheckQueueHandler.state === 'rejected') {
      const data = getCheckerMyQueList()
      if (Array.isArray(data)) {
        setListData(data)
      }
      setLoading(false)
    }
  }, [getCheckerMyQueList, mycheckQueueHandler.state, myCheckerListLength])

  const isFocused = useIsFocused()
  useEffect(() => {
    if (userName && isFocused) {
      setLoading(true)
      lazyFetchMyCheckerList(userName)
      setSideMenuRefresh(true)
      setSearchFilterBy('Entity ID')
    }
  }, [lazyFetchMyCheckerList, userName, isFocused, setSideMenuRefresh, updateFilters, setSearchFilterBy])

  const { width, height } = useWindowDimensions()

  const onPress = (item: any) => {
    setSearchFilterBy('Entity ID')
    resetFeePkgId()
    resetCheckerApplicationStatus()
    console.log('onRowPress', JSON.parse(JSON.stringify(item)))
    if (item?.applicationStatus === 'Pending' || item?.applicationStatus === 'Pending For Approval') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_MYQUEUE', isApprovedByChecker: false, showApproveReject: true },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Error') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_MYQUEUE', isApprovedByChecker: true, showApproveReject: false },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Rejected') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: { data: item, from: 'CHECKER_MYQUEUE', isApprovedByChecker: false, showApproveReject: true },
          },
        ],
      })
    } else if (item?.applicationStatus === 'Completed') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'searchEntity',
            params: {
              data: item,
              from: 'CHECKER_MYQUEUE',
              isApprovedByChecker: false,
              showApproveReject: false,
            },
          },
        ],
      })
    }
    setSideMenuRefresh(true)
  }

  const onStatusPress = (item: any) => {
    console.log('onStatusPress', item)
  }

  const fetchDataOnChange = () => {
    console.count('===> fetchDataOnChange')
    if (userName) {
      setLoading(true)
      lazyFetchMyCheckerList(userName)
    }
  }

  const onFilterPress = () => {
    setFilterVisible(false)
    resetState()
  }

  const applyFilter = () => {
    fetchDataOnChange()
    setFilterVisible(false)
  }

  const handleFilterVisibility = (visible: boolean) => {
    setFilterVisible(visible)
    if (visible) {
      saveState()
    }
  }
  const restoreFilterDefaults = () => {
    restoreFiltersToDefaults()
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <Box {...styles.container}>
      <ModBox show={!showStatus}>
        <Header
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={handleFilterVisibility}
          filterApplied={
            selectedFilteredData?.applicationStatus?.length > 0 &&
            !selectedFilteredData?.applicationStatus?.includes('ALL')
          }
        />
        <ModBox padding={16} show={!filterVisible} minHeight={height <= 720 ? 600 : undefined}>
          <NewTable
            data={listData}
            rowHeight={48}
            headerHeight={64}
            height={544}
            customWidthFunc={getCustomColumnWidth}
            tableWidth={width > 1200 ? width - 290 : width}
            headerRowKeys={myQueueHeaderTitles}
            onRowClick={onPress}
            isStatusClickable={true}
            onStatusPress={onStatusPress}
          />
        </ModBox>
        <ModBox show={filterVisible}>
          <Filters
            onPress={onFilterPress}
            selectedFilteredData={selectedFilteredData}
            updateFilters={updateFilters}
            filterData={[filtersData]}
            checkSelected={checkSelected}
            apply={applyFilter}
            selectedValue={selectedFilteredData?.applicationStatus}
            mode={filterTypes.applicationStatus}
            restoreDefaults={restoreFilterDefaults}
          />
        </ModBox>
      </ModBox>
      <ModBox show={showStatus}>
        <CreationStatus
          onGotoSettings={() => setShowStatus(false)}
          type={EmType.myQueue}
          isValidToProceed={() => navigation.navigate('createEntityGroup')}
          showSuccess
          handleParentBack={() => setShowStatus(false)}
        />
      </ModBox>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    minHeight: 720,
  } as BoxProps,
  header: {
    flexDirection: 'row',
    p: 16,
    h: 100,
    w: '100%',
    marginBottom: 16,
  } as BoxProps,
  footer: {
    p: 16,
    direction: 'row',
    justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
    h: 80,
  } as BoxProps,
}
export default MyQueue
